import {configureStore} from '@reduxjs/toolkit';
import MetricReducer from '../ReduxStore/Metric';
import OnboardReducer from '../ReduxStore/OnboardSlice';
import Request from './Request';


export const Store = configureStore({

    reducer:{
        metric: MetricReducer,
        onboard: OnboardReducer,
        request: Request
    }

})